import api from "@/api/api";

export function getEnvironment() {
  let temp = window.location.hostname;
  if (
    api == "http://172.23.157.234:8889" ||
    temp == "haiwai.yangtuobang.com" ||
    api == "https://haiwai.yangtuobang.com"
  ) {
    return "ytb";
  }
  else if (
    api == "https://oms.supervia.com.cn:8001" ||
    temp == "oms.supervia.com.cn"
  ) {
    return "supervia";
  }
  return "estp";
}

export function getEnvironmentAssets(type) {
  // 页面标题
  const titles = {
    estp: "易速菲海外仓系统-让中国电商轻松入驻东南亚",
    ytb: "洋驼帮海外仓系统-让中国电商轻松入驻东南亚",
    supervia: "超维海外仓系统-让中国电商轻松入驻东南亚",
  };
  if (type === "title") {
    return titles[environment] || "易速菲海外仓系统-让中国电商轻松入驻东南亚";
  }

  // 设置favicon
  const faviconPaths = {
    estp: "/loginlogo.png",
    ytb: "/ytb_icon.png",
    supervia: "/supervia_icon.png",
  };

  const favicon = document.querySelector('link[rel="icon"]');
  if (favicon && type === "favicon") {
    return faviconPaths[environment] || "/loginlogo.png";
  }
}

export const environment = getEnvironment();
